import { computed, isObservableArray } from 'mobx';

import FanClubStore from 'stores/FanClubStore';
import MyShopStore from 'stores/MyShopStore';
import ProfileStore from 'stores/ProfileStore';

import GalleryStore from '../../../ProfileV2Mobile/MobileGallery/GalleryStore';


class LatestContentStore {
  /**
   * Prepares latest content
   * Converts added date or updated date in timestamps in galleries
   * Checks if there is response in videos and sorting the latest content.
   * Gets the 4 or 8 items depends on how much items are in the array.
   * @returns {array} - mixed videos and galleries of last uploaded content
   */
  @computed get latestContent() {
    const { hasNewFanClub } = ProfileStore;
    const { galleriesWithTimeStamps } = GalleryStore;
    const { performerVideos } = MyShopStore;
    let latestContentSortedItems = [];

    if (isObservableArray(performerVideos) && !hasNewFanClub) {
      latestContentSortedItems = MyShopStore.performerVideos
        .concat(GalleryStore.galleriesWithTimeStamps)
        .sort((a, b) => b.dateAdded - a.dateAdded);
    } else {
      latestContentSortedItems = galleriesWithTimeStamps
        .sort((a, b) => b.dateAdded - a.dateAdded)
        .filter((gallery) => gallery.galleryType !== 'FANCLUB');
    }

    const latestContent =
      latestContentSortedItems.length > 4 ? latestContentSortedItems.slice(0, 8) : latestContentSortedItems.slice(0, 4);

    return latestContent;
  }

  @computed get isLatestContentVisible() {
    const { hasNewFanClub } = ProfileStore;
    if (isObservableArray(MyShopStore.performerVideos) && !hasNewFanClub) {
      return (
        MyShopStore.performerVideos.concat(
          GalleryStore.galleries.filter((gallery) => gallery.imageCount > 0)
        ).length > 1
      );
    }

    if (GalleryStore.galleries.length) {
      return (
        GalleryStore.galleries
          .filter((gallery) => gallery.imageCount > 0)
          .filter((gallery) => {
            if (FanClubStore.isFanClubActive && !hasNewFanClub) {
              return gallery;
            }

            return gallery.galleryType !== 'FANCLUB';
          }).length > 1
      );
    }

    return false;


  }

  @computed get isLatestContendLoading() {
    return MyShopStore.performerVideosLoading && GalleryStore.isLoadingGalleries;
  }
}

export default new LatestContentStore();
